import { PhysicalSecurity } from "./PhysicalSecurity";

export default PhysicalSecurity;
